import { requestPost } from '@/common/request';

interface reqParams {
  id?: number; //	规则id	修改时必传
  groupId: number; //	分组id	是	网关
  messageSource?: string; //	消息来源	否   不传默认营销中心	网关
  messageCode?: string; //	消息编号	否   不传默认yx.jd.com	网关
}

interface ResultData {
  data: boolean;
}

/**
 * 消息中心-保存修改规则
 * 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=1121439607
 */
export default function genericGroupSaveRule(query: reqParams): Promise<RequestResult<ResultData>> {
  return requestPost('/generic/platMktMsgBk/group/saveRule', query);
}
